import { TextWithHover } from "../../ToolTip/ToolTip";
import { showDateAndTime } from "../../utils/showDateAndTime";

export const headerForConsignmentFiles = [
  "CATEGORY",
  "SUB CATEGORY",
  "REFERENCE NO",
  "UPLOADED BY",
  "UPLOAD DATE",
  "FILE TYPE",
  "NAME",
];

export const tableFileDataElements = (file, lengthOfChar, getFileUrl) => {
  const [uploadDate = null, uploadDateWithTime = null] = showDateAndTime(file?.date_of_creation);

  return {
    CATEGORY: (
      <td key="Category">
        <TextWithHover noOfChar={lengthOfChar} text={file?.document_category?.name} />
      </td>
    ),
    "SUB CATEGORY": (
      <td key=" sub cat">
        <TextWithHover noOfChar={lengthOfChar} text={file?.document_sub_category?.name} />
      </td>
    ),
    "REFERENCE NO": (
      <td key="ref">
        <TextWithHover noOfChar={lengthOfChar} text={file?.reference_no || "--"} />
      </td>
    ),
    "UPLOADED BY": (
      <td key="uploaded by">
        <TextWithHover noOfChar={lengthOfChar} text={file?.created_by?.full_name} />
      </td>
    ),
    "UPLOAD DATE": (
      <td key="uploaded date" title={uploadDateWithTime ? uploadDateWithTime : ""}>
        {uploadDate || "--"}{" "}
      </td>
    ),
    "FILE TYPE": <td key="file type">{file?.file_detail?.extension || "--"} </td>,
    NAME: (
      <td key="name" className="nameOfFile">
        {getFileUrl && file?.file_url ? (
          <a
            className="fileNameOpenLink"
            href={getFileUrl(file)}
            rel="noopener noreferrer"
            target="_blank"
          >
            <TextWithHover noOfChar={lengthOfChar} text={file?.file_name || "--"} />
          </a>
        ) : (
          <TextWithHover noOfChar={lengthOfChar} text={file?.file_name || "--"} />
        )}
      </td>
    ),
  };
};

export const rowDataOfFileTable = (order, headerList, emptyColRef, getFileUrl) => {
  let lengthOfChar = 15;
  if (emptyColRef.current?.getBoundingClientRect().width > 200) {
    lengthOfChar = 25;
  }
  const allElements = tableFileDataElements(order, lengthOfChar, getFileUrl);
  return headerList.map(item => allElements[item]);
};
